import { proxy, useSnapshot } from 'valtio';

const themeState = proxy({
  theme: localStorage.getItem('ms-ui-theme') || 'light',
  setTheme: (newTheme) => {
    localStorage.setItem('ms-ui-theme', newTheme);
    themeState.theme = newTheme;

    const root = document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(newTheme);
  },
});

// Ensure the initial theme is set on load
themeState.setTheme(themeState.theme);

// Hook for consuming theme
export function useTheme() {
  return useSnapshot(themeState);
}

export default themeState;
